module.exports = __webpack_public_path__ + "media/img/vca/sponsors/onthelist-c06c0de7c7460319ace836f5fb92eb78.png";